import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LocalStorage} from 'ngx-store';

@Injectable()
export class QuizService {
//   private REST_API_SERVER = 'http://127.0.0.1:1234/questions/SPQ';
//   constructor(private httpClient: HttpClient) {}
//   public get_questions(){
//     return this.httpClient.get(this.REST_API_SERVER)
//   }
// }

    api: string = environment.apiUrl;
    @LocalStorage('loggedUser') loggedUser: any;
    @LocalStorage('userData') userData: any;
    lan = localStorage.getItem("lan")

    constructor(private http: HttpClient) {if (this.lan == null){ this.lan = 'en'}}
    async get_questions(type): Promise<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
        return await this.http
            .get(this.api + `/questions/`+ type+ `?language=` + this.lan, {headers, observe: 'response', }).toPromise();
    }

    async post_answers(body): Promise<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
        return this.http
            .post(this.api + `/question/answer`, body, {headers, observe: 'response'})
            .toPromise();
    }
    async check_exp(type): Promise<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
        return await this.http
            .get(this.api + `/check/`+ type, {headers, observe: 'response'}).toPromise();
    }
}


